import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import DenverSlideshow from './DenverSlideshow';
import DenverStories from './DenverStories';
import { createFolderTree } from '../../../utils/shared.js';


const SLIDESHOW_CYCLE_SECONDS_DEFAULT = 5;
const STORIES_CYCLE_SECONDS_DEFAULT = 5;

class DenverContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      slideshowImages: [],
      stories: []
    };
    this._slideshowRef = null;
    this._storiesRef = null;
  }

  componentDidMount() {
    this._cycleInterval = setInterval(() => {
      this.timedCycle();
    }, 1000);
  }

  timedCycle = () => {
    this._slideshowRef.timedCycle();
    this._storiesRef.timedCycle();
  }

  render() {
    const height = window.innerHeight;
    const width = window.innerWidth;

    return (
      <div className="denver-stories__container vertical-screen-x1">
        <DenverSlideshow
          ref={ref => this._slideshowRef = ref}
          images={this.props.slideshowImages}
          cycleOverrides={[]}
          defaultCycleTime={SLIDESHOW_CYCLE_SECONDS_DEFAULT}
          height={height}
          width={width}
          screenOffset={0}
          screen={this.props.screen}      
        />
        <DenverStories
          ref={ref => this._storiesRef = ref}
          cycleTime={7}
          screen={this.props.screen}
          stories={this.props.stories}
          //donors={this.state.donors}
          story_categories={this.props.content.story_categories}
          folder_modules={this.props.content.folder_modules}
          donors={this.props.donors}
          content={this.props.content}
          defaultCycleTime={STORIES_CYCLE_SECONDS_DEFAULT}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const rootFolderId = _.get(state.content, 'settings.selected_root_folder', null);
  const rootFolder = state.content.story_categories.find((folder) => {
    return folder.id === Number(rootFolderId);
  });
  
  const attractLoopFolder = state.content.story_categories.find((folder) => 
    folder.parent_category === Number(rootFolderId) &&
    folder.contents.custom_fields.folder_type.val.value === 'attract_loop_donor_stories'
  );

  const folderTree = createFolderTree(
    state.content.story_categories,
    state.content.folder_modules,
    null,
    state.content.stories,
    state.content.dm_active,
    attractLoopFolder.name,
    null
  );
  
  folderTree.children.map(x=> {
    let folder_module = _.find(state.content.folder_modules, {id: x.folder_module_id});
    x.folder_module_rank = folder_module.rank
    return x;
  })

  folderTree.children = _.orderBy(folderTree.children, "folder_module_rank", "asc");

  const slideshowImages = [];
  if (Array.isArray(rootFolder.contents.images)) {
    if (rootFolder.contents.images[0]) {
      slideshowImages.push(rootFolder.contents.images[0]);
    }
  }

  return {
    // active_module: active_module,
    content: state.content,
    // contentHasErrored: state.contentHasErrored,
    // contentIsLoading: state.contentIsLoading,
    donors: state.donors,
    // donorsHasErrored: state.donorsHasErrored,
    // donorsIsLoading: state.donorsIsLoading,
    screen: state.screen,
    options: state.options,
    screensNumber: state.screensNumber,
    slideshowImages,
    stories: folderTree.children
    //slideshowImages: tempSlideshowImages
    // idleActive: idleActive
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};


export default connect(mapStateToProps, mapDispatchToProps)(DenverContainer);


// WEBPACK FOOTER //
// ./src/Components/Theme/Denver/DenverStoriesContainer.js